import React, { useState, useEffect } from 'react';
import DataTablePublications from '../components/ui/DataTablePublications.jsx';
import { OptimizedImage } from '../components/ui/optimized-image';
const Publications = () => {
  const [headerImageUrl, setHeaderImageUrl] = useState(null);

  useEffect(() => {
    // Récupérer l'image header de la page depuis le backend
    const fetchPageHeader = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/site/pages/publications`);
        if (response.ok) {
          const data = await response.json();
          if (data.header_image) {
            setHeaderImageUrl(`${process.env.REACT_APP_BACKEND_URL}/api/files/${data.header_image}`);
          }
        }
      } catch (error) {
        console.error('Erreur chargement header image:', error);
      }
    };

    fetchPageHeader();
  }, []);

  return (
    <div className="min-h-screen bg-white">
      {/* Header image section */}
      {headerImageUrl && (
        <div 
          className="relative w-full overflow-hidden"
          style={{ 
            height: '600px',
            marginTop: '-80px',
            paddingTop: '80px'
          }}
        >
          <OptimizedImage 
            src={headerImageUrl}
            alt="Publications"
            className="absolute inset-0 w-full h-full object-cover"
            priority={true}
            placeholder="blur"
          />
          <div className="absolute inset-0 bg-black bg-opacity-30"></div>
          <div className="absolute inset-0 flex flex-col items-center justify-center" style={{ paddingTop: '100px' }}>
            <h1 
              className="text-5xl font-bold text-center px-4"
              style={{ 
                fontFamily: '"Lora", serif',
                color: 'rgb(196, 150, 96)',
                textShadow: '3px 3px 6px rgba(0,0,0,0.8), -1px -1px 2px rgba(255,255,255,0.3)'
              }}
            >
              Publications
            </h1>
            <p 
              className="text-2xl text-center px-4 mt-3"
              style={{ 
                fontFamily: '"Lora", serif',
                color: 'white',
                textShadow: '2px 2px 4px rgba(0,0,0,0.8)'
              }}
            >
              Liste des publications disponibles
            </p>
          </div>
        </div>
      )}

      <div className="py-16 bg-gray-50">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Header sans image */}
          {!headerImageUrl && (
            <div className="text-center mb-8">
              <h1 
                className="text-5xl font-bold mb-2"
                style={{ fontFamily: '"Lora", serif', color: 'rgb(196, 150, 96)' }}
              >
                Publications
              </h1>
              <p 
                className="text-gray-600"
                style={{ fontFamily: '"Lora", serif', fontSize: '17px' }}
              >
                Liste des publications disponibles
              </p>
            </div>
          )}

          <DataTablePublications pageLengthDefault={100} showDateColumn={false} />
        </div>
      </div>
    </div>
  );
};

export default Publications;